import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Sparkles, Coffee, ExternalLink, Zap } from 'lucide-react';
import BrandLogo from './BrandLogo';

export default function Footer() {
  return (
    <footer className="w-full bg-slate-950/90 backdrop-blur-xl border-t border-white/10 text-slate-400 font-sans mt-auto">
      <div className="max-w-7xl mx-auto px-6 py-16 space-y-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">

          {/* Column 1: Brand Tagline & Coffee Link */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <BrandLogo />
            </Link>
            <p className="text-xs text-slate-400 leading-relaxed">
              The digital curator experience. Stream M3U & IPTV playlists with maximum freedom, glassmorphic UI, and multi-view grid capabilities.
            </p>
            <a
              href="https://buymeacoffee.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-2xl bg-amber-500/10 border border-amber-400/30 text-amber-300 text-xs font-bold hover:bg-amber-500/20 transition shadow-lg shadow-amber-500/10"
            >
              <Coffee size={16} className="text-amber-400" />
              <span>Buy Us a Coffee</span>
              <ExternalLink size={12} className="opacity-70" />
            </a>
          </div>

          {/* Column 2: Features */}
          <div className="space-y-3">
            <h4 className="text-xs font-extrabold text-white uppercase tracking-wider">Features & Tools</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/tools" className="text-amber-400 hover:text-amber-300 transition font-extrabold flex items-center gap-1.5"><Zap size={13} className="text-amber-400 fill-amber-400" /> IPTV Developer Tools</Link></li>
              <li><a href="/#features" className="hover:text-white transition">Features Overview</a></li>
              <li><a href="/#how-it-works" className="hover:text-white transition">How It Works</a></li>
              <li><Link to="/m3u-player" className="hover:text-white transition">M3U Player Tool</Link></li>
              <li><Link to="/chromecast-iptv" className="hover:text-white transition">AirPlay & Chromecast</Link></li>
              <li><Link to="/player" className="hover:text-white transition">Multi-View 2x2 Grid</Link></li>
            </ul>
          </div>

          {/* Column 3: Company & Help */}
          <div className="space-y-3">
            <h4 className="text-xs font-extrabold text-white uppercase tracking-wider">Company & Help</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/about" className="hover:text-white transition">About Us</Link></li>
              <li><Link to="/guides" className="hover:text-white transition">Setup Guides</Link></li>
              <li><Link to="/faq" className="hover:text-white transition">FAQ & Support</Link></li>
              <li><a href="mailto:support@webiptvplayer.com" className="hover:text-white transition">Contact Us</a></li>
              <li><Link to="/profile" className="hover:text-amber-400 text-amber-300 font-bold transition flex items-center gap-1.5"><Sparkles size={12} /> Go Premium</Link></li>
            </ul>
          </div>

          {/* Column 4: Legal & Policy */}
          <div className="space-y-3">
            <h4 className="text-xs font-extrabold text-white uppercase tracking-wider">Legal</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/terms" className="hover:text-white transition">Terms of Service</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition">Privacy Policy</Link></li>
              <li><Link to="/cookies" className="hover:text-white transition">Cookie Policy</Link></li>
              <li><Link to="/refund" className="hover:text-white transition">Refund Policy</Link></li>
            </ul>
            <div className="pt-2">
              <p className="text-[10px] text-slate-500 leading-relaxed">
                <strong>Disclaimer:</strong> Web IPTV Player is a media player interface. It does not host, provide, or distribute any media content or TV channels.
              </p>
            </div>
          </div>

        </div>

        {/* Bottom Copyright Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Web IPTV Player. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/" className="hover:text-slate-300 transition">Home</Link>
            <span>•</span>
            <Link to="/profile" className="hover:text-slate-300 transition">Profile</Link>
            <span>•</span>
            <Link to="/chromecast-iptv" className="hover:text-slate-300 transition">Casting</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
